import React from 'react';
import { formatNumberWithCommas } from '../../../../../utils/utils';
import classes from './StatCard.module.css';

const StatCard = ({ number, text, image, imageAlt }) => {

    return (
        <div className={classes.card}>
            <div className={classes.cardContent}>
                <div className={classes.cardRight}>
                    {image && <img src={image} alt={imageAlt || ''} className={classes.image} />}
                </div>
                <div className={classes.cardLeft}>
                    <div className={classes.number}>{formatNumberWithCommas(number)}</div>
                    <div className={classes.text}>{text}</div>
                </div>
            </div>
        </div>
    );
};

export default StatCard;

